import { ataChaptersQuery } from "@common/api/ata-chapter"
import { currentUserQuery } from "@common/api/users"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@common/components/ui/dialog"
import { hasPermission } from "@common/lib/permissions"
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { NewTaskForm } from "../-components/form/new-task-form"

export const Route = createFileRoute(
  "/_layout/work-orders/$workOrderId/tasks/new",
)({
  beforeLoad: async ({ context: { queryClient }, params, search }) => {
    const me = await queryClient.ensureQueryData(currentUserQuery())
    if (!hasPermission(me, "work_task:create")) {
      throw redirect({ to: "/work-orders/$workOrderId", params, search })
    }
  },
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(ataChaptersQuery()),
  component: NewTaskDialog,
})

function NewTaskDialog(): React.ReactElement {
  const { workOrderId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () =>
    navigate({
      to: "/work-orders/$workOrderId",
      params: { workOrderId },
      search: true,
    })

  return (
    <Dialog open onOpenChange={(open) => !open && close()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New task</DialogTitle>
          <DialogDescription>Add a task to this work order.</DialogDescription>
        </DialogHeader>
        <NewTaskForm
          workOrderId={workOrderId}
          onCreated={(task) => {
            showToast("Created", "Task added to the work order.", "success")
            navigate({
              to: "/work-orders/$workOrderId/tasks/$taskId",
              params: { workOrderId, taskId: task.id },
              search: true,
            })
          }}
          onCancel={close}
        />
      </DialogContent>
    </Dialog>
  )
}
